<template>
  <head>
    <meta charset="utf-8" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <title>Boutique | Ecommerce bootstrap template</title>
    <meta name="description" content="" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta name="robots" content="all,follow" />

    <!-- Favicon-->
    <link rel="shortcut icon" href="../../template/img/favicon.png" />
  </head>
</template>

<script>
export default {
  name: "Header",
};
</script>

<style>
</style>